// src/config.js

// Accessing NODE_ENV, which is set by CRA based on the process (npm start, npm test, npm run build)
const environment = process.env.REACT_APP_ENV

// Define URLs or other constants based on the environment
let CONFIG

switch (environment) {
    case 'production':
        CONFIG = {
            TMD_URL: 'https://apply.tmdsas.com',
            JAMP_URL: 'https://apply.texasjamp.org',
            ENVIRONMENT: 'production',
        }
        break
    case 'development':
        CONFIG = {
            TMD_URL: 'http://localhost:53016',
            JAMP_URL: 'http://localhost:53033',
            ENVIRONMENT: 'development',
        }
        break
    case 'test':
        CONFIG = {
            TMD_URL: 'https://test.tmdsas.com',
            JAMP_URL: 'https://test.texasjamp.org',
            ENVIRONMENT: 'test',
        }
        break
    default:
        console.error(`Unknown environment: ${environment}`)
        // Default configuration (could be development or minimal config)
        CONFIG = {
            TMD_URL: 'http://localhost:53016',
            JAMP_URL: 'http://localhost:53033',
            ENVIRONMENT: 'development',
        }
        break
}

// Export the CONFIG object using ES module syntax
export default CONFIG
